export const windowMessages = {
  CLOSE_PREVIEW: 'close-preview'
}
